import { Controller } from '@hotwired/stimulus'

// 再検索パネルの「変更する」ボタン。ページ上部の ConditionSearch モーダルを
// 該当タブ（modalIndex: エリア=0 / 料金=1 / 介護医療=2）で開く。
export default class extends Controller {
  openModal (e) {
    const modalIndex = Number(e.currentTarget.dataset.modalIndex)
    window.dispatchEvent(new CustomEvent('open-condition-search-modal', { detail: { modalIndex } }))
  }
}
